module.exports = __webpack_public_path__ + "static/media/community.33a10559.svg";